import React, {  useState } from 'react';
import SpinnCircle from './SpinnCircle';
import { getStreakCountApi } from "../Surveystreak.api";
import { useAuth } from "context/auth-context";
import { useTranslation } from "react-i18next";
import { FiAward, FiGift } from "react-icons/fi";

type SetShowSpinnerType = (value: boolean) => void;
const  Spinner = ({setShowSpinner}: { setShowSpinner: SetShowSpinnerType })=> {
const { t } = useTranslation();
const [result, setResult] = useState(null);
  const [spinning, setSpinning] = useState(false);

  const { auth } = useAuth();

const creditPoints = result;
const getSurveyvirtualwallet = (auth,creditPoints:number) => {
  getStreakCountApi(auth?.panelistId,creditPoints);
};
 
const getPoint = ()=>{

  if(result){
    getSurveyvirtualwallet(auth,creditPoints);
    setShowSpinner(false);
  }
};

const angles = [90,  180, 225, 270, 315];
const handleSpinClick = () => {
  if (!spinning) {
    setSpinning(true);
    
    const spinUntilDesiredValue = () => {
      const container = document.querySelector('.container') as HTMLElement;
      const randomAngle = angles[Math.floor(Math.random() * angles.length)];
      const totalRotation = 18;
      const spinningDuration = 10; 
      container.style.transition = `transform ${spinningDuration}s ease-in-out`;
      container.style.transform = `rotate(${totalRotation * 360 + randomAngle}deg)`;
      setTimeout(() => {
        const computedStyle = window.getComputedStyle(container);
        const transform = computedStyle.getPropertyValue('transform');
        const matrix: string[] = transform.split('(')[1].split(')')[0].split(',');
        const angle = Math.round(Math.atan2(parseFloat(matrix[1]), parseFloat(matrix[0])) * (180 / Math.PI));
        let point: number;
        
        const positiveAngle = angle !== -90 ? Math.abs(angle) : angle;
         if (positiveAngle === 225 || positiveAngle === 315) {
          
          spinUntilDesiredValue();
        } else {
switch (positiveAngle) {
          case 0:
            point = 55;
            break;
          case -90:
            point = 75;
            break;
          case 180:
            point = 200;
            break;
          case 45:
            point = 350;
            break;
          case 90:
            point = 150;
            break;
          case 135:
            point = 125;
            break;
          default:
            point = null;
        }
          setResult(point);
          setSpinning(false);
        }
      }, spinningDuration*1000); 
    };
    spinUntilDesiredValue();
  }
};

  return (
    <div>
      <div className="zs-backdrop" role="dialog" aria-modal="true" aria-labelledby="spin-wheel-title">
        <div className="zs-modal max-w-[400px] text-center">
          <div className="px-5 pt-6 sm:px-7 sm:pt-7">
            <span
              className={`inline-flex items-center justify-center w-11 h-11 mb-3 rounded-lg ${
                result ? "bg-success-soft text-success" : "bg-primary-soft text-primary-text"
              }`}
              aria-hidden="true"
            >
              {result ? <FiAward className="w-5 h-5" /> : <FiGift className="w-5 h-5" />}
            </span>
            {!result ? (
              <>
                <h2 id="spin-wheel-title" className="text-xl font-bold tracking-tight font-display text-ink">
                  {t("spin.modal.Wheel")}!
                </h2>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-3">
                  <span>{t("spin.modal.before")} </span>
                  <span>{t("spin.modal.issuing")} </span>
                </p>
              </>
            ) : (
              <>
                <h2 id="spin-wheel-title" className="text-xl font-bold tracking-tight font-display text-ink">
                  {t("spin.modal.Congratulation")}!
                </h2>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-3">
                  <span>
                    {t("spin.modal.won")} <span className="font-semibold tabular-nums text-success">{result}</span>{" "}
                    {t("spin.modal.Points")}
                  </span>
                </p>
              </>
            )}
          </div>

          <div className="flex items-center justify-center px-5 py-6">
            <SpinnCircle result={result} spinning={spinning} handleSpinClick={handleSpinClick} />
          </div>

          <div className="px-5 pb-6 sm:px-7 sm:pb-7">
            {result ? (
              <button className="zs-btn zs-btn-primary zs-btn-lg zs-btn-block" onClick={getPoint}>
                {t("spin.modal.Pointscollect")}
              </button>
            ) : (
              <p className="text-xs text-ink-4">{spinning ? "Spinning..." : "Tap Spin to reveal your reward."}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};


export default Spinner;
